<template>
  <div :class="{'slo-label': true, 'slo-label--error': error}" v-bind="$attrs" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SloLabel',
  props: {
    error: {type: [Boolean, String], default: false}
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/system';

.slo-label {
  @include text('sm', 'strong');
  color: $color-gray-700;

  &--error {
    color: $color-red-400 !important;
  }
}
</style>
